import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Visualizer from "../containers/visualizer/Visualizer";
import Routes from "./Routes";
import Landing from "../containers/landing/Landing";
import View from "../containers/view/View";
import Auth from "../containers/auth/Auth";
import Dashboard from "../containers/dashboard/Dashboard";

class RouterBox extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path={Routes.root} component={Landing} />
          <Route exact path={Routes.visualizer} component={Visualizer} />
          <Route exact path={Routes.auth} component={Auth} />
          <Route exact path={Routes.home} component={Dashboard} />
          <Route path={Routes.view} render={(props) => <View {...props} />} />
        </Switch>
      </Router>
    );
  }
}
export default RouterBox;
